import StyledTextFieldWithTitle from "@/modules/common/components/input/styled-text-field-with-title";
import { FinancialDetailsFormFields } from "@/modules/property-tracks/hooks/rental-financial-proposal/multi-step-form.hook";
import { Box, Typography } from "@mui/material";
import { useEffect } from "react";
import { Controller, UseFormReturn, useWatch } from "react-hook-form";

interface FinancialCostSharePaymentProps {
  form: UseFormReturn<FinancialDetailsFormFields>;
  index: number;
  totalCount: number;
  totalAmount: number;
  remove: (index: number) => void;
}

export default function FinancialCostSharePayment({
  form,
  index,
  totalAmount,
}: FinancialCostSharePaymentProps) {
  // const costShareAmount = form.getValues("paymentPlan") || 0;

  const percentage =
    useWatch({
      control: form.control,
      name: `paymentPlan.${index}.percentage`,
    }) || 0;

  useEffect(() => {
    const amount = totalAmount ? (totalAmount * percentage) / 100 : 0;
    form.setValue(`paymentPlan.${index}.amount`, amount);
  }, [totalAmount, percentage, index, form]);

  return (
    <Box
      sx={(t) => ({
        p: t.nawy.spacing.sm,
        backgroundColor: t.nawy.colors.semantic.layer.secondary,
        borderRadius: t.nawy.radius.xl,
        display: "flex",
        flexDirection: "column",
        gap: t.nawy.spacing.xxs,
      })}
    >
      <Typography
        sx={(t) => t.nawy.typography.english.variants.body.md.semibold}
      >
        Month {index + 1}
      </Typography>
      <Box
        sx={(t) => ({
          display: "flex",
          gap: t.nawy.spacing.xs,
          p: t.nawy.spacing.md,
          backgroundColor: t.nawy.colors.primitives.white[100],
          borderRadius: t.nawy.radius.xl,
        })}
      >
        <Controller
          control={form.control}
          name={`paymentPlan.${index}.percentage`}
          render={({ field, fieldState }) => (
            <StyledTextFieldWithTitle
              {...field}
              formatNumeric
              title="Percentage"
              placeholder="Percentage"
              fullWidth
              size="small"
              error={!!fieldState.error}
              helperText={fieldState.error?.message}
              slotProps={{
                input: {
                  endAdornment: <Typography>%</Typography>,
                },
              }}
            />
          )}
        />
        <Controller
          control={form.control}
          name={`paymentPlan.${index}.amount`}
          render={({ field, fieldState }) => (
            <StyledTextFieldWithTitle
              {...field}
              formatNumeric
              title="Amount"
              placeholder="Amount"
              fullWidth
              size="small"
              disabled={true}
              error={!!fieldState.error}
              helperText={fieldState.error?.message}
              slotProps={{
                input: {
                  endAdornment: <Typography>EGP</Typography>,
                },
              }}
            />
          )}
        />
        {/* {totalCount > 1 ? (
        <IconButton
          variant="outlined-primary"
          color="error"
          onClick={() => remove(index)}
        >
          <Trash2
            style={{
              width: 18,
              height: 18,
            }}
          />
        </IconButton>
      ) : (
        <></>
      )} */}
      </Box>
    </Box>
  );
}
